module.exports = __webpack_public_path__ + "static/media/Leonardo.18af9bae.png";